module.exports = __webpack_public_path__ + "media/images/frontend/clock-0fa7b34528ea85c217547ab39913f471.svg";